import {WorkflowInstanceStepEditModel} from "./workflow-instance-step-edit.model";
import {WorkflowStep} from "../../../enums/WorkflowStep";
import {BatchModel} from "../../batch/batch.model";
import {WorkflowStepDnaExtractionModel} from "../workflow-step-dna-extraction.model";
import {WorkflowStepDnaExtractionSwabLysisModel} from "../workflow-step-dna-extraction-swab-lysis.model";
import {WorkflowStepNormalisation} from "../workflow-step-normalization.model";

export class WorkflowInstanceStepNormalizationEditModel extends WorkflowInstanceStepEditModel {

  batches: BatchModel[];

  static initFromStep(step: WorkflowStepNormalisation): WorkflowInstanceStepEditModel {
    const ret = new WorkflowInstanceStepNormalizationEditModel();
    ret.workflowStep = WorkflowStep.NORMALIZATION;
    ret.workflowInstanceStepId = step.id;
    ret.batches = step.batches;
    return ret;
  }

}
